/* eslint-disable react/jsx-props-no-spreading */
import * as ReactDOMClient from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ListingProvider from '../ListingProvider';
import { getApiHostname } from 'cms/constants';
import { Listing } from '../Listing';
import type { ListingProps } from '../ListingContext';

const queryClient = new QueryClient();

interface ArticleListingInitProps {
    el: HTMLDivElement;
    props: ListingProps;
}

const ArticleListingInit = ({ el, props }: ArticleListingInitProps): void => {
    const root = ReactDOMClient.createRoot(el);
    const fetchURL = `${getApiHostname()}/api/articles`;

    root.render(
        <QueryClientProvider client={queryClient}>
            <ListingProvider {...props}>
                <Listing
                    fetchUrl={fetchURL}
                    type={'article'}
                />
            </ListingProvider>
        </QueryClientProvider>
    );
};

export default ArticleListingInit;


